<template>
  <div class="setting-container">
    <button class="general-button-wrapper" @click="toggleModal">
      <IconDownload class="icon-medium" />
      <p class="small">{{ t('download_call_history') }}</p>
    </button>

    <Teleport to="body">
      <DownloadTableModal v-if="showModal" :chat-type="chatType" @close="toggleModal" />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import DownloadTableModal from '@/components/domains/chat/script-download/ChatScriptDownloadModal.vue';
import IconDownload from '@/components/icons/IconDownload.vue';
import { TypeCall } from '@/types/common';
import { CHAT_TYPES } from '@/utils/constants/chat';

const { t } = useI18n();
const route = useRoute();

const showModal = ref<boolean>(false);

const chatType = computed<TypeCall>(() => {
  const { chatType = 'GENERAL' } = route.meta;
  return Object.keys(CHAT_TYPES).includes(chatType) ? chatType : 'GENERAL';
});

const toggleModal = () => {
  showModal.value = !showModal.value;
};
</script>

<style scoped lang="scss">
.general-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  border-radius: 8px;
  padding: 0;
  gap: 0.75rem;
  color: var(--font-default);
  overflow: hidden;
  z-index: 0;
  flex-shrink: 0;
  height: 40px;
  transition:
    border-radius 0.5s ease,
    background-color 0.5s ease;
}

.setting-container {
  position: relative;
  width: 100%;
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  background: var(--surface-default);
  border-radius: 8px;
}
</style>
